import React from 'react';
import $ from "jquery";
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Icon, Label, Input, Table, Button } from 'semantic-ui-react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import makeDeceimalPoints from '../../makedecimalpoints';
import Server from '../../../functions/server';
import Loading from '../../loadings';
import ReadCookie from '../../../functions/readcookies';

class AddSparesinCombo extends React.Component {

  state = {
    spares: [], newCombos: [], fullWidth: true, maxWidth: 'lg',
  }

  addSparesinCombo() {
    let context = this;
    let data = (ReadCookie("branch"));
    let branch_id;
    for (var i = 0; i < data.length; i++) {
      branch_id = data[i].branch_id;
    }
    context.setState({ load: true, message: 'Getting Spares!!!' }) 
    $.ajax({
        type: 'POST',
        data: { 'branch': branch_id, 'customer': 96 },
        url: Server() + 'purchasedetail/getpartcode.php',
        success: function(data) {
          let comboSpares = context.props.comboSpares;
          try {
            data = JSON.parse(data);
            let spares = [];
            data.map((c) => {
                let value = 1;
                comboSpares.map((s) => {
                    if (c.part_alias == s.partno) {
                        value = 0;
                    }
                })
                if (value == 1) {
                    spares.push(c);
                }
            })
            context.setState({ spares, load: false, openAddComboSparesDialog: true })

          } catch (error) {
             context.setState({ load: false }) 
          }
        },
        error: function(err) {
          context.setState({ load: false });
          alert('Try again!!!!')
        }
      });
  }

  addNewComboSpares() {
      let newCombos = this.state.newCombos;
      let id = 1;
      newCombos.map((c) => {
        id = id + 1;
        c.id = id;
      })
      id = id + 1;
      newCombos.push({ id: id })
      this.setState({ newCombos })
  }

  partcode = (id) => event => {
    let value = event.target.value;
    let dropdown =  event.target.value;
    let brand_Name = value.split('->')[3];
    let spare = this.state.spare;
    value = value.split('->')[0];
    let data = this.state.spares;
    let newCombos = this.state.newCombos;
    let mrp, tax, partno, partname, brand_id;
    data.map((z) => {
        if (value == z.part_alias && brand_Name == z.brand_name) {
            mrp = z.mrp; tax = z.tax; partno = z.partno; brand_id = z.brand_id;
        }
    })
    mrp = this.convertIntoNumber(mrp);
    tax = this.convertIntoNumber(tax);
    mrp = mrp + ((mrp * tax)/100);
    newCombos.map((c) => {
        if (c.id == id) {
            c.dropdown = dropdown;
            c.mrp = mrp;
            c.originalmrp = mrp;
            c.partno = partno;
            c.brand_id = brand_id;
        }
    })
    this.setState({ newCombos })
  }

  convertIntoNumber(value) {
    try {
        value = Number(value);
    } catch (error) {
        value = 0;
    }
    return value;
  }

  onChangeTextBox = (type, id) => (f, { value }) => {
    let newCombos = this.state.newCombos;
    newCombos.map((c) => {
        if (type == 'unit') {
            if (c.id == id) {
                c.unit = value;
                c.disc = 0;
                c.mrp = c.originalmrp;
                c.discrs = 0;
            } 
        }
        if (type == 'disc') {
            if (c.id == id) {
                c.disc = value;
                c.mrp = c.originalmrp - ((c.originalmrp * value)/100);
                c.discrs = ((c.originalmrp * value)/100);
            }
        }
        if (type == 'discrs') {
            if (c.id == id) {
                c.discrs = value;
                if (!value) {
                    value = 0;
                }
                let mrp = (c.originalmrp * c.unit) - ((c.originalmrp * c.unit) - value);
                let discount = mrp/(c.originalmrp * c.unit) * 100;
                c.disc = discount;
                c.mrp = c.originalmrp - ((c.originalmrp * discount)/100);
            }
        }
    })
    this.setState({ newCombos })
  }

  deleteItem(id) {
    let newCombos = this.state.newCombos;
    let newCombosItem = [];
    newCombos.map((c) => { if (c.id != id) { newCombosItem.push(c); } })
    let ids = 0;
    newCombosItem.map((c) => { ids = ids + 1; c.id = ids; })
    this.setState({ newCombos: newCombosItem })
  }

  save() {
      let context = this;
      let newCombos = this.state.newCombos;
      newCombos = JSON.stringify(newCombos);
      let cook = (ReadCookie("vaigai"));
      let by = cook.id;
      let data = { 'newCombos': newCombos, 'id': context.props.id, 'by': by };
      $.ajax({
        type: 'POST', data,
        url: Server() + 'combo/addsparesincombo.php',
        success: function(data) {
          if (data == 1) {
              context.setState({ openAddComboSparesDialog: false, load: false })
              context.props.reloadComboSpares();
          }    
          else {
              alert('Error!!!');
              context.setState({ load: false })
          } 
        },
        error: function(err) {
          context.setState({ load: false });
          alert('Try again!!!!')
        }
      });
  }

  render() {
    const { classes } = this.props;
    let sino = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Button onClick={this.addSparesinCombo.bind(this)}>ADD</Button><br/><br/>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}  open={this.state.openAddComboSparesDialog}
        onClose={ () => { this.setState({ openAddComboSparesDialog: false }) }} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Add Spares in Combo</DialogTitle>
                <DialogContent>
  
                <Table celled id="table">
                    <Table.Header style={{backgroundColor: '#abb119'}}>
                        <Table.Row>
                            <Table.HeaderCell>Sino</Table.HeaderCell>
                            <Table.HeaderCell>Partno</Table.HeaderCell>
                            <Table.HeaderCell>Units</Table.HeaderCell>
                            <Table.HeaderCell>Mrp</Table.HeaderCell>
                            <Table.HeaderCell>Dis(%)</Table.HeaderCell>
                            <Table.HeaderCell>Dis Rs</Table.HeaderCell>
                            <Table.HeaderCell>Total</Table.HeaderCell>
                            <Table.HeaderCell>Action</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            this.state.newCombos.map((c) => {
                                let mrp = this.convertIntoNumber(c.mrp);
                                let unit = this.convertIntoNumber(c.unit);
                                return (
                                    <Table.Row>
                                        <Table.Cell>{sino++}</Table.Cell>
                                        <Table.Cell>
                                        <datalist id="suggestionspartno">
                                            {this.state.spares.map((c) => {
                                            return (
                                                <option id='box'>
                                                    {c.part_alias+'->'+c.spare_name+'->'+c.partno+'->'+c.brand_name}
                                                </option>
                                            )
                                            })}
                                        </datalist>
                                        <input style={{height: 35, width: '100%'}} 
                                        onChange={this.partcode(c.id)} autoComplete="on" list="suggestionspartno" 
                                        value={c.dropdown} id={c.id} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Input fluid placeholder='UNIT' value={c.unit} onChange={this.onChangeTextBox('unit', c.id)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            {makeDeceimalPoints(c.mrp)}
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Input fluid placeholder='Dis(%)' value={c.disc} onChange={this.onChangeTextBox('disc', c.id)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Input fluid placeholder='Dis(Rs)' value={c.discrs} onChange={this.onChangeTextBox('discrs', c.id)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            {makeDeceimalPoints(mrp * unit)}
                                        </Table.Cell>
                                        <Table.Cell onClick={this.deleteItem.bind(this, c.id)}>
                                            Delete
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            })
                        }
                    </Table.Body>
                </Table>

                <br/>
                <Button onClick={this.addNewComboSpares.bind(this)}>Add</Button>
                <Button onClick={this.save.bind(this)}>SAVE</Button>
            </DialogContent>
        </Dialog>
      </div>
    );
  }
}
export default AddSparesinCombo;